import React, { createContext, useState } from "react";
import { ICollection } from "../../Models/ICollections";
import { Active } from "../../Models/IUser";



const RequestContext = createContext({});

interface Props {
  children: React.ReactNode;
}

export const RequestProvider = (props: Props) => {
  const [url, setUrl] = useState("");
  const [shouldRefetch, refetch] = useState({default: true});
  const [active, setActive] = useState<Active>();
  const [policy, setPolicy] = useState<string>("");
  const [collections, setCollections] = useState<ICollection[]>([]);
  const [permMappingDict, setPermMappingDict] = useState<Record<string, number>>({});

  const createPermMappingDict = () => {
    let dict: Record<string, number> = {};

    collections.forEach(collection => {
      collection.permissions.forEach(perm => {
        dict[perm.permissionName] = perm.id
      })
    });
    console.log(dict);
    setPermMappingDict(dict);
  }

  const mapPermissionNamesToIds = (perms: string[]): number[] => {
    if (Object.keys(permMappingDict).length === 0) {
      createPermMappingDict();
    }
    
    let ids: number[] = [];
    perms.forEach(perm => {
      ids.push(permMappingDict[perm]);
    });
    
    return ids;
  }

  return (
    <RequestContext.Provider
    value={{
      url,
      setUrl,
      refetch,
      shouldRefetch,
      active,
      setActive,
      policy,
      setPolicy,
      collections,
      setCollections,
      mapPermissionNamesToIds,
      createPermMappingDict,
      permMappingDict,
    }}
    >
      {props.children}
    </RequestContext.Provider>
  );
}

export default RequestContext;